// Fails open (returns true) if sessionStorage throws (private browsing, etc).
export function isFirstAttemptForPathname(
  keyPrefix: string,
  pathname: string,
): boolean {
  try {
    const retryKey = `${keyPrefix}:${pathname}`
    if (sessionStorage.getItem(retryKey)) return false
    sessionStorage.setItem(retryKey, "1")
    return true
  } catch {
    return true
  }
}
